module.exports = __webpack_public_path__ + "img/gif.6f2789e0.svg";